import type { ReactNode } from "react";

interface PageHeroProps {
  badge?: string;
  title: ReactNode;
  description?: string;
  backgroundImage: string;
  children?: ReactNode;
  minHeight?: string;
}

export default function PageHero({
  badge,
  title,
  description,
  backgroundImage,
  children,
  minHeight = "min-h-[420px] md:min-h-[520px]",
}: PageHeroProps) {
  return (
    <section className={`relative ${minHeight} flex items-end overflow-hidden`}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt="Sayfa Arka Plan"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-900/70 to-primary-950/90" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-20 pt-32 md:pt-36">
        <div className="max-w-7xl mx-auto">
          {badge && (
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm rounded-full text-sm font-medium text-primary-200 mb-5 border border-primary-400/30">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400" />
              {badge}
            </div>
          )}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            {title}
          </h1>
          {description && (
            <p className="text-white/75 text-lg md:text-xl max-w-3xl leading-relaxed">
              {description}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}